import axios from 'axios'
import Cookies from 'js-cookie'
import { ILocalUser } from '../@types'
import cookieKeys from '../database/cookie-keys'
import { ENV } from '../env'

function isPrismaError(error: { error: string }): boolean {
  return (
    error &&
    typeof error.error === 'string' &&
    error.error.includes('prismaClient')
  )
}

const api = axios.create({ baseURL: ENV.VITE_API_BASE_URL })

api.interceptors.request.use((config) => {
  const cookie = Cookies.get(cookieKeys.auth) ?? null

  if (cookie) {
    const localUser = JSON.parse(cookie) as ILocalUser
    const { token } = localUser

    if (token) config.headers.set('Authorization', `Bearer ${token}`)
  }

  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      if (error.code === 'ERR_NETWORK') {
        return Promise.reject(
          new Error('Erro de ligação, verifique a sua internet!'),
        )
      }

      if (error.response && error.response.data) {
        const errorData = error.response.data

        if (isPrismaError(errorData)) {
          return Promise.reject(
            new Error('Ocorreu um erro inesperado no servidor.'),
          )
        }

        if (errorData.errors && Array.isArray(errorData.errors)) {
          const errorMessage = errorData.errors.join(', ')
          return Promise.reject(new Error(errorMessage))
        }

        if (errorData.error) {
          return Promise.reject(new Error(errorData.error))
        }

        if (errorData.message) {
          return Promise.reject(new Error(errorData.message))
        }
      }
    }

    return Promise.reject(error)
  },
)

export default api
